import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DELIVERY_NOTES_OVERVIEW,
  DeliveryNoteState,
  deliveryNotesFeatureKey,
  DELIVERY_NOTE,
  marketplaceDeliveryNotesFeatureKey,
} from './delivery-notes.reducer';

export const selectDeliveryNoteState = createFeatureSelector<DeliveryNoteState>(
    deliveryNotesFeatureKey
);

export const selectMarketplaceDeliveryNoteState = createFeatureSelector<DeliveryNoteState>(
    marketplaceDeliveryNotesFeatureKey
);

//******************************************************

export const selectOverview = createSelector(
    selectDeliveryNoteState,
  (state: DeliveryNoteState) =>
    state[DELIVERY_NOTES_OVERVIEW].deliveryNotesOverview
);

export const loadingOverview = createSelector(
    selectDeliveryNoteState,
  (state: DeliveryNoteState) =>
    state[DELIVERY_NOTES_OVERVIEW].isLoading
);

export const errorOverview = createSelector(
    selectDeliveryNoteState,
  (state: DeliveryNoteState) =>
    state[DELIVERY_NOTES_OVERVIEW].error
);

export const selectMarketplaceOverview = createSelector(
  selectMarketplaceDeliveryNoteState,
(state: DeliveryNoteState) =>
  state[DELIVERY_NOTES_OVERVIEW].deliveryNotesOverview
);

//******************************************************

export const selectDeliveryNote = createSelector(
    selectDeliveryNoteState,
  (state: DeliveryNoteState) =>
    state[DELIVERY_NOTE].deliveryNote
);

export const selectMarketplaceDeliveryNote = createSelector(
  selectMarketplaceDeliveryNoteState,
(state: DeliveryNoteState) =>
  state[DELIVERY_NOTE].deliveryNote
);

export const loadingDeliveryNote = createSelector(
    selectDeliveryNoteState,
  (state: DeliveryNoteState) =>
    state[DELIVERY_NOTE].isLoading
);

export const errorDeliveryNote = createSelector(
    selectDeliveryNoteState,
  (state: DeliveryNoteState) =>
    state[DELIVERY_NOTE].error
);


